import { ooFetchWithResponse } from './ooFetchWithResponse';

let tagApi = {
    getTaggablePeople: async () => {
        let url = 'tags/v1/people';
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
    getActiveTaggablePeople: async () => {
        let url = 'tags/v1/people/active';
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
    addPerson: async (name, birthday) => {
        let url = 'tags/v1/people';
        let body = JSON.stringify({ name: name, birthday: birthday });
        let response = await ooFetchWithResponse(url, { method: "POST", body: body });
        return response;
    },
    setPersonActive: async (peopleID, active) => {
        let url = `tags/v1/people/${peopleID}/active`;
        let body = JSON.stringify({ active: active });
        let response = await ooFetchWithResponse(url, { method: "PUT", body: body });
        return response;
    },
    tagPeople: async (photoID, peopleID) => {
        let url = 'tags/v1';
        let body = JSON.stringify({ photoID: photoID, peopleID: peopleID });
        let response = await ooFetchWithResponse(url, { method: "POST", body: body });
        return response;
    },
}

export { tagApi };